module.exports = __webpack_public_path__ + "img/em-pros-01.0e17f521.png";